import {Trigger} from '../../models/trigger';
import {startsWith} from 'lodash';

export function getTriggerEvent(trigger: Trigger) {
  return startsWith(trigger.event, 'time') ? 'time' : trigger.event;
}
